import { Reducer } from 'redux'
import { ModalSubscriptionsActionTypes } from './action'
import { ChannelPartnerPrivateOfferInCreation } from '../channelPartnerPrivateOffer/reducer'
import {
  AgreementBasedOfferData,
  AgreementBasedOfferWithSaveData,
  GcpSubscriptionDetailsResponse,
  SubscriptionDetailObject,
  SubscriptionObject,
  SubscriptionsAPIResponse,
} from '../subscription/reducer'

export type AgreementBasedOffer = AgreementBasedOfferData &
  AgreementBasedOfferWithSaveData

export interface ModalSubscriptionsState extends SubscriptionsAPIResponse {
  subscriptions: SubscriptionObject[]
  noOfPage: number | null
  currentSubscription: { [x: string]: SubscriptionDetailObject }
  currentGcpSubscription: { [x: string]: GcpSubscriptionDetailsResponse }
  currentAgreementInCreation: {
    [x: string]: AgreementBasedOffer
  }
  currentCPPOAgreementInCreation: {
    [x: string]: ChannelPartnerPrivateOfferInCreation
  }
}

const initialState: ModalSubscriptionsState = {
  subscriptions: [],
  pageNumber: 0,
  noOfPage: null,
  pageSize: 10,
  count: 0,
  sortBy: '',
  sortOrder: 'desc',
  currentSubscription: {},
  currentGcpSubscription: {},
  currentAgreementInCreation: {},
  currentCPPOAgreementInCreation: {},
}

type actionType =
  | {
      type: ModalSubscriptionsActionTypes.SET_MODAL_SUBSCRIPTIONS_DATA
      payload: { data: SubscriptionObject[] } & SubscriptionsAPIResponse
    }
  | {
      type: ModalSubscriptionsActionTypes.CLEAR_MODAL_SUBSCRIPTIONS_DATA
    }

export const reducer: Reducer<ModalSubscriptionsState, actionType> = (
  state: ModalSubscriptionsState = initialState,
  action
) => {
  switch (action.type) {
    case ModalSubscriptionsActionTypes.SET_MODAL_SUBSCRIPTIONS_DATA: {
      const existingIds = new Set(
        state.subscriptions.map(sub => sub.subscriptionId)
      )
      const newSubscriptions = action.payload.data.filter(
        sub => !existingIds.has(sub.subscriptionId)
      )

      return {
        ...state,
        subscriptions: state.subscriptions.concat(newSubscriptions),
        pageNumber: action.payload.pageNumber,
        count: action.payload.count,
        noOfPage: Math.ceil(
          (action.payload.count ?? 0) / action.payload.pageSize
        ),
        sortBy: action.payload.sortBy,
        sortOrder: action.payload.sortOrder,
      }
    }
    case ModalSubscriptionsActionTypes.CLEAR_MODAL_SUBSCRIPTIONS_DATA: {
      return {
        ...state,
        subscriptions: [],
        noOfPage: null,
        count: 0,
        pageNumber: 0,
      }
    }

    default:
      return state
  }
}
